import { useEffect } from "react"
import { useMap } from "react-leaflet"
import L from "leaflet"

const FitBoundsToData = ({ data }) => {
  const map = useMap()

  useEffect(() => {
    if (data?.features?.length > 0) {
      const layer = L.geoJSON(data)
      const bounds = layer.getBounds()
      if (bounds.isValid()) {
        map.flyToBounds(bounds, {
          padding: [10, 10],
          duration: 1.5,
          easeLinearity: 0.5,
        })
      }
    }
  }, [data, map])

  return null
}

export default FitBoundsToData
